"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VendorRFPLost = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.VendorRFPLost = typebox_1.Type.Object({
    vendor_name: typebox_1.Type.String(),
    first_name: typebox_1.Type.String(),
    proposal_number: typebox_1.Type.String(),
    lost_message: typebox_1.Type.String(),
});
//# sourceMappingURL=vendor-rfp-lost.js.map